// Author Lin
// Date 2021-11-20 09:21:28

class MintalMesPrdPelletizingGrindingParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                bn101 = '',
                bn102 = '',
                bn103 = '',
                bn104 = '',
                semiCokeQuantity = '',
                dolomiteMagnesiteQuantity = '',
                returnOreQuantity = '',
                grindingQuantity = '',
                millWaterAddition = '',
                steelBallQuantity = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.bn101 = bn101;
            this.bn102 = bn102;
            this.bn103 = bn103;
            this.bn104 = bn104;
            this.semiCokeQuantity = semiCokeQuantity;
            this.dolomiteMagnesiteQuantity = dolomiteMagnesiteQuantity;
            this.returnOreQuantity = returnOreQuantity;
            this.grindingQuantity = grindingQuantity;
            this.millWaterAddition = millWaterAddition;
            this.steelBallQuantity = steelBallQuantity;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingGrindingParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn101',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.bn101',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn102',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.bn102',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn103',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.bn103',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn104',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.bn104',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'semiCokeQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.semiCokeQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dolomiteMagnesiteQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.dolomiteMagnesiteQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'returnOreQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.returnOreQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'grindingQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.grindingQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'millWaterAddition',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.millWaterAddition',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'steelBallQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.steelBallQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            bn101Filter : '',
            bn102Filter : '',
            bn103Filter : '',
            bn104Filter : '',
            semiCokeQuantityFilter : '',
            dolomiteMagnesiteQuantityFilter : '',
            returnOreQuantityFilter : '',
            grindingQuantityFilter : '',
            millWaterAdditionFilter : '',
            steelBallQuantityFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'bn101',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.bn101',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn102',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.bn102',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn103',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.bn103',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn104',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.bn104',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'semiCokeQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.semiCokeQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dolomiteMagnesiteQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.dolomiteMagnesiteQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'returnOreQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.returnOreQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'grindingQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.grindingQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'millWaterAddition',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.millWaterAddition',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'steelBallQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.steelBallQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingGrindingParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingGrindingParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        